import React, { useState, useEffect, useRef } from 'react';
import * as d3 from "d3";
import { checkValue } from '../utils/NumberUtils';
const PurchaseMonthlyGraph = (current) => {
    const [label] = useState([1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1])
    // const filteredData = current && current.monthly && current.monthly !== null && Object.keys(current.monthly).length !== 0 ? current.monthly.recv_power.filter(data => typeof data === 'number') : [0, 0];
    const data = current && current.monthly && current.monthly !== null && Object.keys(current.monthly).length !== 0 ? checkValue(current.monthly.recv_power) : [0, 0];
    const maxData = current.max;
    const svgRef = useRef();

    useEffect(() => {
        const width = 155;
        const height = 45;
        const svg = d3.select(svgRef.current)
            .attr('width', width)
            .attr('height', height)
            .attr('transform', 'translate(20,0)')
            .style('overflow', 'visible')
            .style('color', '#fff')
            .style('font', '12px Inter')
            .style('font-weight', 'normal')
            .style('margin-top', '-10px')
            .style('margin-left', '-25px')

        svg.selectAll("*").remove();


        const xScale = d3.scaleBand()
            .domain(label.map((val, i) => i))
            .range([0, width])
            .padding(0.2);

        const yScale = d3.scaleLinear()
            .domain([0, maxData ? maxData : 40000])
            .range([height, 0]);


        const yAxis = d3.axisRight(yScale)
        // .ticks(5)
        // .tickSize(-width);


        svg.selectAll('.bar')
            .data(label)
            .join('line')
            .call(drawLineBar);

        svg.selectAll('.bar')
            .data(data && data.length !== 0 ? data : 0)
            .join('line')
            .call(drawLineBar2);

        svg.append("text")
            .text("今月")
            .attr("x", 0)
            .attr("y", 60)
            .style('fill', '#ff8028')
            .style('font', '14px Inter')
            .style('font-weight', '400');

        svg.append("text")
            .text(maxData ? `${((maxData / 1000).toFixed(0))}kWh` : '100kWh')
            .attr("x", 152)
            .attr("y", 7)
            .style('fill', '#ff8028')
            .style('font', '10px Inter')
            .style('font-weight', '400');

        svg.append("text")
            .text("0kWh")
            .attr("x", 152)
            .attr("y", 45)
            .style('fill', '#ff8028')
            .style('font', '10px Inter')
        // .style('font-weight', 'bold');





        function drawLineBar(g) {
            //customize label color 
            g.call(yAxis)
                .attr('x1', (v, i) => xScale(i))
                .attr('y1', (val) => yScale(val))
                .attr('x2', (v, i) => xScale(i))


                // .attr('y2', (val) => height)
                // .attr('stroke-dasharray', 1.5)
                .style('stroke', '#b4b2b2')
                .style('stroke-width', '2');
        }
        function drawLineBar2(g) {
            //customize color based on data
            g.call(yAxis)
                .attr('x1', (v, i) => xScale(i))
                .attr('y1', (val) => yScale(val))
                .attr('x2', (v, i) => xScale(i))
                .attr('y2', (val) => height)
                .style('stroke', '#ff8028')
                .style('stroke-width', '2')
        }
        // eslint-disable-next-line
    }, []);


    return (
        <svg ref={svgRef} id="weathergraph" />
    )
}
export default PurchaseMonthlyGraph;